var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnbounding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08773 7.57584L1.29668 9.3669C0.580542 10.083 0.580542 11.2441 1.29668 11.9603L1.29668 11.9603C2.01282 12.6764 3.1739 12.6764 3.89003 11.9603L5.68109 10.1692C6.39722 9.45306 6.39722 8.29198 5.68109 7.57585L5.68109 7.57584C4.96495 6.85971 3.80387 6.85971 3.08773 7.57584Z",
    stroke: "#141E2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62362 2.0402L6.83256 3.83125C6.11643 4.54739 6.11643 5.70847 6.83256 6.42461L6.83257 6.42461C7.5487 7.14075 8.70979 7.14075 9.42592 6.42461L11.217 4.63355C11.9331 3.91742 11.9331 2.75634 11.217 2.0402L11.217 2.0402C10.5008 1.32406 9.33976 1.32406 8.62362 2.0402Z",
    stroke: "#141E2F",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21802 9.0392L8.25819 4.99902",
    stroke: "#141E2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnbounding);
export default __webpack_public_path__ + "static/media/ic_unbounding.11ae000ff1a30252c031bb10123b1a44.svg";
export { ForwardRef as ReactComponent };